<template>
  <div
    :class="componentClass"
    :style="componentStyle"
  >
    <article
      :class="`card roomy ${theme}`"
      style="--link-color: var(--fa-dk-blue); --link-hover-color: var(--fa-blue)"
    >
      <div class="header padding-y-4xl">
        <owa-sample-spinner size="4x" />
      </div>
      <div class="section text-left">
        <h1 class="h4 margin-bottom-md">{{ title }}</h1>

        <p>
          {{ content }} Taking too long?
          <a
            href="mailto:hello@fontawesome.com?subject=A page won't load, Font Awesome"
            @click="supportLinkClicked('page_loading')"
            >Let us know</a
          >!
        </p>
      </div>
    </article>
  </div>
</template>

<script>
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'PageLoading',

    mixins: [EventTrackingMixin],

    props: {
      content: {
        type: String,
        default: "We're getting this page decorated in your honor."
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      lineLength: {
        type: String,
        default: 'sm'
      },
      theme: {
        type: String,
        default: 'yellow'
      },
      title: {
        type: String,
        default: 'Hang Tight...'
      }
    },

    computed: {
      componentClass() {
        return [`margin-auto line-length-${this.lineLength}`]
      },
      componentStyle() {
        return {
          ...this.customStyle
        }
      }
    }
  }
</script>
